export function getCreateProjectHref(full = false) {
  if (full) {
    return 'https://www.relume.io/app/project/create';
  }
  return `/app/project/create`;
}

type GetProjectUrlOpts = {
  /** Indicates if the AI assistant should generate the space when the page is loaded. */
  generateOnLoad?: boolean;
  /** Contains the domain (e.g. www.example.com) from where the site was imported.
   * This information will be used when the page is load to execute post-import logic. */
  sitemapImportedFrom?: string;
};

export function getProjectUrl(
  projectToken: string,
  { generateOnLoad = false, sitemapImportedFrom }: GetProjectUrlOpts = {},
) {
  const url = new URL(`/app/project/${projectToken}`, window.location.href);

  if (generateOnLoad) {
    url.searchParams.set('generateOnLoad', 'true');
  }
  if (sitemapImportedFrom) {
    url.searchParams.set('sitemapImportedFrom', sitemapImportedFrom);
  }

  return url.href;
}

export function getProjectCommentUrl(projectToken: string, threadId: number) {
  const params = new URLSearchParams({
    goToCommentThread: threadId.toString(),
  });
  return `${getProjectUrl(projectToken)}#${params.toString()}`;
}

export function getLogoutHref() {
  return `/app/logout`;
}
